import { tv } from 'tailwind-variants'

export const rewardChipVariants = tv({
  base: [
    'relative inline-flex items-center',
    'h-[39px]',
    'gap-1',
    'text-md font-medium text-white',
    'overflow-hidden rounded-tl-sm rounded-tr-20 rounded-br-20 rounded-bl-sm bg-glass-overlay-light bg-primary-background/80'
  ],
  variants: {
    accentColor: {
      none: '',
      yellow: 'shadow-yellow-top-accent-inset',
      green: 'shadow-green-top-accent-inset',
      blue: 'shadow-blue-top-accent-inset'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})

export const rewardChipIconVariants = tv({
  base: [
    'flex justify-center items-center',
    'h-full w-[24px]',
    'rounded-l-sm rounded-r-14 shadow-white-top-accent-inset'
  ],
  variants: {
    accentColor: {
      none: '',
      yellow: 'bg-yellow',
      green: 'bg-dark-green',
      blue: 'bg-blue'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})
